// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3C3E_","inputWrap":"Table_inputWrap__1e92A","col":"Table_col__2FCAt","bmiTooltip":"Table_bmiTooltip__1_Ykg"};